import notificationsService from '../../services/notificationsService'

class NotificationsController {
  changeActionedStatus = notificationsService.changeActionedStatus
  fetchNotificationsForUser = notificationsService.fetchNotificationsForUser
}

export default new NotificationsController()
 


// WEBPACK FOOTER //
// ../src/controllers/notificationsController/notificationsController.js